import React from "react";
import { PageContent, CustomBreadcrumb } from "components/Common";
import KHCLRevenueReport from "./KHCLRevenueReport";
import { ModuleIds } from "constant";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

const RESOURCE = ModuleIds.KHCLRevenueReport;

const KHCLRevenueReportContainer = ({ t }) => {
  const titleTag = t("Báo cáo doanh số nhóm KHCL");
  return (
    <PageContent title={t(titleTag)}>
      {/* Page Title */}
      <CustomBreadcrumb
        breadcrumbItem={titleTag}
        resource={RESOURCE}
        icon={<i className="bx bx-file" />}
      />
      {/* Page Body */}
      <KHCLRevenueReport />
    </PageContent>
  );
};

KHCLRevenueReportContainer.propTypes = {
  t: PropTypes.any,
};

export default withTranslation(["sitePage"])(KHCLRevenueReportContainer);
